import Vue from 'vue';

Vue.component('shelf-space-plan-index', () =>
    import('./shelf-space-plan-index.vue'),
);

Vue.component('shelf-space-plan-product-index', () =>
    import('./shelf-space-plan-product-index.vue'),
);
